import { Injectable } from '@angular/core';
import { Store, State } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Loadable } from '../common/loadable';
import { AppState } from '../app.state';
import {
    ChangeMultiInvoiceSortExpressionAction,
    ChangeMultiInvoiceFilterExpressionAction,
    ChangeMultiInvoicePageAction,
    LoadMultiInvoicePageAction,
    ChangeMultiInvoiceTotalCountAction
} from './action';

import { Paging } from '..';
import { MultiInvoiceState } from './state';
import { MultiInvoiceApiService } from 'src/api/services/multi-invoice-api.service';
import { toNumber } from 'lodash';
import { MultiInvoice } from './state-models/multi-invoice';

@Injectable()
export class MultiInvoiceStateService {
    private resources = require('../../state/common/resources.json');
    constructor(
        private multiInvoiceApiService: MultiInvoiceApiService,
        private appStore: Store<AppState>,
        private appState: State<AppState>) { }

    @Loadable()
    async loadMultiInvoice(
        allocationScaniaUnitId: number,
        from: string,
        to: string,
        paging: Paging,
        sortExpression: string,
        filterExpression: string,
        forceRefetch: boolean = false) {
        const payload = {
            from: new Date(from).toISOString(),
            to: new Date(to).toISOString(),
            allocationScaniaUnit: toNumber(allocationScaniaUnitId),
            paging: paging,
            order: sortExpression,
            filter: filterExpression
        };
        const multiInvoice = await this.multiInvoiceApiService.getMultiInvoiceList(payload, forceRefetch); 

        this.appStore.dispatch(new LoadMultiInvoicePageAction(multiInvoice.list));
        this.appStore.dispatch(new ChangeMultiInvoiceTotalCountAction(multiInvoice.totalCount));
    }

    async refetchList(allocationScaniaUnitId: number, from: string, to: string): Promise<void> { 
        const state = <MultiInvoiceState>this.appState.getValue().multiInvoice;
        await this.loadMultiInvoice(allocationScaniaUnitId, from, to, state.multiInvoicePaging, state.multiInvoiceSortExpression, state.multiInvoiceFilterExpression);
    }

    getList(): Observable<MultiInvoice[]> {
        return this.appStore.select(state => state.multiInvoice.multiInvoice);
    }

    getSortingExpression(): Observable<string> {
        return this.appStore.select(state => state.multiInvoice.multiInvoiceSortExpression);
    }

    sort(sortExpression: string) {
        this.appStore.dispatch(new ChangeMultiInvoiceSortExpressionAction(sortExpression));
    }

    getFilterExpression(): Observable<string> {
        return this.appStore.select(state => state.multiInvoice.multiInvoiceFilterExpression);
    }

    filter(filterExpression: string) {
        this.appStore.dispatch(new ChangeMultiInvoiceFilterExpressionAction(filterExpression));
    }

    getPaging(): Observable<Paging> {
        return this.appStore.select(state => state.multiInvoice.multiInvoicePaging);
    }

    goToPage(page: number) {
        this.appStore.dispatch(new ChangeMultiInvoicePageAction(page));
    }

    getTotalCount(): Observable<number> {
        return this.appStore.select(state => state.multiInvoice.multiInvoiceTotalCount);
    }

    clearFilterAndSorting() {
        [
            new ChangeMultiInvoiceSortExpressionAction(null),
            new ChangeMultiInvoiceFilterExpressionAction(null)
        ].forEach(action => this.appStore.dispatch(action));
    }
}
